var map = {
	"./papsi_account_disabled.svg": 8441,
	"./papsi_account_green.svg": 3526,
	"./papsi_add.svg": 3218,
	"./papsi_appliance.svg": 1325,
	"./papsi_asterisk.svg": 7005,
	"./papsi_back_grey.svg": 230,
	"./papsi_back_to_back.svg": 7678,
	"./papsi_back_white.svg": 2454,
	"./papsi_backspace.svg": 3150,
	"./papsi_birthday.svg": 8878,
	"./papsi_box.svg": 2132,
	"./papsi_business.svg": 1855,
	"./papsi_calamity.svg": 4087,
	"./papsi_car.svg": 5121,
	"./papsi_check_green.svg": 9667,
	"./papsi_dropdown_grey.svg": 896,
	"./papsi_edit.svg": 8173,
	"./papsi_edit_white.svg": 1575,
	"./papsi_education.svg": 1649,
	"./papsi_emergency.svg": 6284,
	"./papsi_enter.svg": 2165,
	"./papsi_exit_black.svg": 2501,
	"./papsi_exit_grey.svg": 7373,
	"./papsi_exit_red.svg": 705,
	"./papsi_first.svg": 4533,
	"./papsi_first_disabled.svg": 3808,
	"./papsi_forward_grey.svg": 1714,
	"./papsi_group_green.svg": 5714,
	"./papsi_help.svg": 416,
	"./papsi_hide.svg": 9521,
	"./papsi_housing.svg": 1954,
	"./papsi_id.svg": 554,
	"./papsi_info_blue.svg": 500,
	"./papsi_info_green.svg": 9065,
	"./papsi_last.svg": 9281,
	"./papsi_last_disabled.svg": 444,
	"./papsi_loan.svg": 9387,
	"./papsi_loans_green.svg": 4614,
	"./papsi_logout.svg": 2927,
	"./papsi_mail.svg": 9068,
	"./papsi_mobile_green.svg": 5363,
	"./papsi_money_bag.svg": 5012,
	"./papsi_money_bag_green.svg": 8624,
	"./papsi_multipurpose.svg": 1238,
	"./papsi_next_green.svg": 194,
	"./papsi_next_grey.svg": 1064,
	"./papsi_passbook.svg": 7033,
	"./papsi_password_invisible.svg": 4842,
	"./papsi_password_visible.svg": 7385,
	"./papsi_peso_green.svg": 7470,
	"./papsi_petty_cash.svg": 7913,
	"./papsi_pin.svg": 6262,
	"./papsi_placeholder.svg": 6784,
	"./papsi_prev_disabled.svg": 4177,
	"./papsi_prev_green.svg": 1310,
	"./papsi_providential.svg": 160,
	"./papsi_qr.svg": 4044,
	"./papsi_qr_black.svg": 1128,
	"./papsi_qr_green.svg": 152,
	"./papsi_salary.svg": 8843,
	"./papsi_savings.svg": 2426,
	"./papsi_savings_green.svg": 542,
	"./papsi_share_capital.svg": 8303,
	"./papsi_share_green.svg": 2706,
	"./papsi_show.svg": 5554,
	"./papsi_smartphone.svg": 6824,
	"./papsi_smartphone_green.svg": 6092,
	"./papsi_summary.svg": 5895,
	"./papsi_ticket.svg": 3593,
	"./papsi_ticket_grey.svg": 7349,
	"./papsi_user.svg": 1808
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5853;